// Public admin forgot-password page. Anti-enumeration — always shows same message.
import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, Shield } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await axios.post(`${API}/admin/auth/forgot-password`, { email: email.trim().toLowerCase() });
            setSent(true);
        } catch (_) {
            setSent(true); // still show the same success message for anti-enumeration
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0b1f22] text-ivory flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-gold">
                        <Shield size={12} /> Serenity Cove · Staff
                    </div>
                    <h1 className="font-display text-4xl text-ivory mt-4">Reset your password</h1>
                    <p className="text-ivory/60 text-sm mt-3">Enter the email you use to sign in. If it matches a staff account, we'll email you a reset link.</p>
                </div>

                {sent ? (
                    <div data-testid="forgot-sent" className="bg-white/[0.04] border border-white/10 rounded-2xl p-8 text-center">
                        <div className="text-gold text-[10px] uppercase tracking-[0.24em]">Check your inbox</div>
                        <p className="mt-3 text-ivory/85 text-sm leading-relaxed">If an account exists for that email, a reset link has been sent. It expires in 1 hour.</p>
                        <Link to="/admin/login" className="mt-6 inline-block text-[11px] uppercase tracking-[0.2em] text-ivory/60 hover:text-gold">← Back to sign in</Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="bg-white/[0.04] border border-white/10 backdrop-blur-md rounded-2xl p-8" data-testid="admin-forgot-form">
                        <label className="block">
                            <span className="text-[10px] uppercase tracking-[0.22em] text-ivory/60">Email</span>
                            <div className="mt-2 flex items-center gap-3 border border-white/15 rounded-lg px-4 py-3 bg-black/20 focus-within:border-gold/50 transition-colors">
                                <Mail size={15} className="text-ivory/40" />
                                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                    className="bg-transparent outline-none w-full text-ivory text-sm" placeholder="you@serenitycoveresorts.com" />
                            </div>
                        </label>
                        <button type="submit" disabled={busy} className="mt-6 w-full bg-gold text-navy px-6 py-3.5 rounded-full text-[11px] uppercase tracking-[0.24em] font-bold hover:bg-gold/90 inline-flex items-center justify-center gap-2 disabled:opacity-60">
                            {busy ? "Sending…" : (<>Send reset link <ArrowRight size={13} /></>)}
                        </button>
                        <div className="mt-6 text-center">
                            <Link to="/admin/login" className="text-[11px] uppercase tracking-[0.2em] text-ivory/60 hover:text-gold">← Back to sign in</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
